
import React, { useEffect } from "react";
import CheckoutContainer from "@/components/checkout/CheckoutContainer";
import CheckoutGrid from "@/components/checkout/CheckoutGrid";
import CheckoutForm from "@/components/checkout/CheckoutForm";
import OrderSummary from "@/components/checkout/OrderSummary";
import { useCheckout } from "@/hooks/useCheckout";
import { useCheckoutStore } from "@/stores/checkoutStore";

const Checkout = () => {
  const {
    courseId,
    courseData,
    courseLoading,
    courseError,
    user,
    authLoading,
    loading,
    setLoading,
    userName,
    showAuthForm,
    handleContinueToPayment,
    handleAuthSuccess
  } = useCheckout();
  
  const { discountApplied, recalculateDiscount } = useCheckoutStore();
  
  // Ensure discount calculation is correct when component mounts
  useEffect(() => {
    if (discountApplied && courseData) {
      recalculateDiscount();
    }
  }, [courseData, discountApplied, recalculateDiscount]);
  
  return (
    <CheckoutContainer
      title="Osta kursus"
      courseError={courseError}
      courseLoading={courseLoading}
      courseData={courseData}
    >
      <CheckoutGrid
        mainContent={
          <CheckoutForm
            user={user}
            courseId={courseId}
            authLoading={authLoading}
            showAuthForm={showAuthForm}
            onShowAuth={handleContinueToPayment}
            onAuthSuccess={handleAuthSuccess}
            courseData={courseData}
            userName={userName}
            loading={loading}
            setLoading={setLoading}
          />
        }
        sidebarContent={
          <OrderSummary course={courseData} />
        }
      />
    </CheckoutContainer>
  );
};

export default Checkout;
